import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const notificationImporterSelectors = importerSelectors(
  'notification.importer',
);

export default notificationImporterSelectors;
